import { PageStyle, ModalStyle, ButtonStyle, Button, ClientDashboard, Checkbox, Form, Formik, FormikControl, Image, useEffect, useRouter, useState, clearSWRCache, SelectJobModalAction, ErrorPages, useSWR, CONSTANTS, Loading, InputError, useRef, components, Tooltip, Field } from '@/imports-files/components/model/select-job-modal';
import Modal from "@/components/common-modal/modal";
import { FormModalStyle } from "@/imports-files/components/common-modal/common-modal";

export function ButtonCustomizationModal({formRef, buttonPopup, setButtonPopup, customizeCareerAction})
{
  const formik =  buttonPopup.formik
  const [link, setLink] = useState(formRef.current.values.hero_section_attributes.button_hash.buttons[buttonPopup.button_index].link)
  const [isLink, setIsLink] = useState(formRef.current.values.hero_section_attributes.button_hash.buttons[buttonPopup.button_index].is_link)
  return buttonPopup.state ? (
    <Modal
      type="form"
      heading="Add a link"
      closeModal={() => {
        setButtonPopup({state: false})
      }}
      content={
        <>
        <div className={`${ModalStyle.SetupPopup__ModalContent}`}>
          <div className={`${PageStyle.SelectJob__DisplayFlex} ${ModalStyle.ButtonCustomization__RadioButtons} p0 mt30`}>
            <label className={`Dpflex WrapperRadioContainer mb0 mr15`}>
              <input type="radio" name={`hero_section_attributes.button_hash.buttons.${buttonPopup.button_index}.is_link`} value={'link'}
                defaultChecked={isLink =='link'}
                onChange={async(event)=>
                  {
                    setIsLink(event.target.value)
                    setLink('')
                  }}
                />
              <span className="WrapperRadiocheckmark ml0"></span>
              <span className={`ml0 WrapperRadioSpan pl10`}> Website Link</span>
            </label>
            <label className={`Dpflex WrapperRadioContainer mb0 ml15`}>
              <input type="radio" name={`hero_section_attributes.button_hash.buttons.${buttonPopup.button_index}.is_link`} value={'section'}
                defaultChecked={isLink == 'section'}
                onChange={(event)=>
                  {
                    setIsLink(event.target.value)
                    setLink('')
                  }}
               />
              <span className="WrapperRadiocheckmark ml0"></span>
              <span className={`ml0 WrapperRadioSpan pl10`}> Section</span>
            </label>
          </div>

          <div className={`${PageStyle.SelectJob__Content} mt20 p0`}>
            <label>{isLink == 'link' ? 'Website Link' : 'Section'}</label>
          </div>

          {isLink == 'link' && <div className={`mt15`}>
              <div className={`${PageStyle.SelectJob__CustomSelectWidth} ${ModalStyle.ButtonCustomization__CustomSelectWidth}`}>
                <input
                  className={`${PageStyle.Form__Input} thresholdmodl`}
                  type="text"
                  value={link}
                  defaultValue={''}
                  onChange={(event) => {
                    setLink(event.target.value)
                  }}
                />
              </div>
            </div>
          }
          {isLink == 'section' && <div className={`mt15`}>
            <div className={PageStyle.SelectJob__CustomSelectWidth}>
              <FormikControl
                control         =     "select"
                name            =     {`hero_section_attributes.button_hash.buttons.${buttonPopup.button_index}.link`}
                className       =     {`${PageStyle.CustomSelect}`}
                options         =     {buttonPopup.sections_list}
                onChange        =     {(option)=>{
                  setLink(option.value)
                }}
                default           =     {link}
              />
            </div>
          </div>
          }


          <div className={`${PageStyle.SelectJob__Footer} ${ModalStyle.ButtonCustomization__Footer} ${FormModalStyle.Modal__Container__ButtonSection}`}>
            <div className={`${PageStyle.SelectJob__ButtonAction} ${ModalStyle.ButtonCustomization__Footer__ButtonAction} mt0 mb0`}>
              <Button buttonstyle={`${PageStyle.primarybtn} ${ModalStyle.primarybtn}`}type="button" onClick={async() => {
                await buttonPopup.formik.setFieldValue(`hero_section_attributes.button_hash.buttons.${buttonPopup.button_index}.link`, link)
                await buttonPopup.formik.setFieldValue(`hero_section_attributes.button_hash.buttons.${buttonPopup.button_index}.is_link`, isLink)
                setTimeout(await customizeCareerAction.updateHeroSection(), 100)
                setButtonPopup({state: false})
              }}>
              Save
              </Button>
            </div>
            </div>
          </div>
        </>
      }
      />
    ) : (
        ""
  );
}